import * as React from "react";
import {imageBaseUrl} from "config";

interface IProps {
    duration?: number;
    text?: string;
    onFinish: () => void;
}

interface IState {
    time: number;
}
let timer = null;
const defaultDuration = 15;
const defaultText = "Please wait while we are processing.";
export default class Timer extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            time: props.duration ? props.duration : defaultDuration,
        };
    }
    public renderTimer() {
        return (<div className="col-12" style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
            <div className="col-12 p-2" style={{ display: "flex", justifyContent: "center", alignItems: "center",
                borderRadius: 10, background: "#E96E55", color: "white" }}>
                {this.state.time} sec
            </div>
        </div>);
    }
    public componentDidMount() {
        this.startTimer();
    }

    public startTimer() {
        timer = setInterval(() => {
            if (this.state.time > 0) {
                this.setState({
                    time: this.state.time - 1,
                });
            } else {
                clearInterval(timer);
                this.props.onFinish();
            }
        }, 1000);
    }
    public render() {
        return this.state.time >= 0 ?
            <div className="card">
                <br/>
                <br/>
                <strong>
                    <span className="flex-center" style={{fontSize: 18}}>Please wait a while</span>
                </strong>
                <div className="container-fluid p-2 text-center">
                    <img src={`${imageBaseUrl}/img/icons/processing.jpg`} alt="Timer"
                         style={{width: "50%", padding: 30}}/>
                    <p>{this.props.text ? this.props.text : defaultText}</p>
                    {this.state.time > 0 && this.renderTimer()}
                </div>
            </div> : null;
    }
}
